import React from 'react'
import { useAuth } from './AuthProvider'
import LoginPage from './LoginPage'
import styled from 'styled-components'

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: white;
  color: black;
`

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #ff4444;
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 1rem;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, hasRequiredAccess, user, userGroups } = useAuth()

  console.log('ProtectedRoute: isAuthenticated =', isAuthenticated)
  console.log('ProtectedRoute: isLoading =', isLoading)
  console.log('ProtectedRoute: hasRequiredAccess =', hasRequiredAccess)
  console.log('ProtectedRoute: user =', user)
  console.log('ProtectedRoute: userGroups =', userGroups)

  if (isLoading) {
    return (
      <LoadingContainer>
        <LoadingSpinner />
        <div>Loading...</div>
      </LoadingContainer>
    )
  }

  if (!isAuthenticated) {
    console.log('ProtectedRoute: User not authenticated, showing login page')
    return <LoginPage />
  }

  if (!hasRequiredAccess) {
    console.log('ProtectedRoute: User does not have required access, showing access denied')
    return (
      <LoginPage 
        accessDenied={true}
      />
    )
  }

  console.log('ProtectedRoute: User authenticated and has access, rendering children')
  return <>{children}</>
}

export default ProtectedRoute